import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { APPROVAL_FACILITY_HOLIDAY, APPROVAL_FACILITY_HOLIDAY_SUCCESS, APPROVAL_FACILITY_HOLIDAY_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* approvalFacilityHoliday({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const { approval_id, action } = payload.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/facility-holiday-approval-request/${approval_id}/action`,
      method: 'POST',
      data: { action },
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200 || response.status === 201) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: APPROVAL_FACILITY_HOLIDAY_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: APPROVAL_FACILITY_HOLIDAY_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: APPROVAL_FACILITY_HOLIDAY_ERROR, payload: error });
  }
}

export function* watchApprovalFacilityHoliday() {
  yield takeEvery(APPROVAL_FACILITY_HOLIDAY, approvalFacilityHoliday);
}

function* approvalFacilityHolidaySaga() {
  yield all([fork(watchApprovalFacilityHoliday)]);
}

export default approvalFacilityHolidaySaga;
